import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-s-smiley-sad",
  "use": "icon-s-smiley-sad-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-s-smiley-sad\"><path d=\"M11 0c6.075 0 11 4.925 11 11s-4.925 11-11 11S0 17.075 0 11 4.925 0 11 0m0 2a9 9 0 1 0 0 18 9 9 0 0 0 0-18m0 11c2.69 0 5 1.155 5 3h-2c0-.09-.177-.299-.619-.52-.598-.3-1.454-.48-2.381-.48s-1.783.18-2.381.48c-.442.221-.619.43-.619.52H6c0-1.845 2.31-3 5-3M8.5 7a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m5 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol